import React from 'react';
import { css } from 'glamor';
import { useQuery } from '@apollo/client';
import { rolesQuery } from "../Users/queries";
import * as theme from "../../../theme";
import { CardContainer, Container } from "../../../components/Container";
import {Left, Right} from "../../../components/Header";
import {H1, H2} from "../../../components/Typography";
import { FlashMessage } from "../../../components/FlashMessage";
import { Loading, LoadingError } from "../../../components/LoadingFork";
import { Well } from "../../../components/Well";
import { Table, THead, TBody } from "../../../components/Table";
import { withInstallation } from "../../../components/InstallationContext";
import { Button } from "../../../components/Button";
import authManager from "../../../lib/authManager";

function Header(props) {
    return (
        <div
            className={css({
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'stretch',
            })}
            {...props}
        />
    );
}

const rowStyle = css({
    '> td': {
        verticalAlign: 'middle',
        height: 60,
        borderBottom: `1px solid ${theme.gray10}`,
        transition: 'all .2s linear',
    },
    '> td:first-child': { paddingLeft: 10 },
    '> td:last-child': { paddingRight: 10 },
    ':hover > td': {
        background: theme.gray10,
        cursor: 'pointer',
    },
});

function RoleRow({ role, onClick }) {
    const permissions = role.permissions || [];

    return (
        <tr key={role.id} className={rowStyle} onClick={onClick}>
            <td>{role.name}</td>
            <td>{role.label || '-'}</td>
            <td>{role.description || '-'}</td>
            <td>{permissions.length}</td>
        </tr>
    );
}

function RoleList({ match, location, history }) {
    const { data = {}, loading, error } = useQuery(rolesQuery, {
        fetchPolicy: 'no-cache',
    });

    const roles = data.roles || [];
    const visibleRoles = roles.filter((role) => {
        return role.installationId || authManager.isRootAdmin();
    });

    return (
        <div>
            <CardContainer>
                <Container size="large" spaceAbove="small" spaceBelow="small">
                    <Header>
                        <Left>
                            <H1>Roles</H1>
                        </Left>
                        <Right>
                            <Button to={`${match.url}/new`}>
                                Create new role
                            </Button>
                        </Right>
                    </Header>
                </Container>

                <Container spaceBelow="large">
                    <FlashMessage locationState={location.state} />

                    {loading && <Loading />}
                    {error && <LoadingError error={error} />}

                    {!loading && visibleRoles.length === 0 && (
                        <Well>
                            <div>
                                <H2 spaceBelow="large">No roles available</H2>
                            </div>
                        </Well>
                    )}

                    {!loading && visibleRoles.length > 0 && (
                        <Table>
                            <THead>
                                <tr>
                                    <th>Name</th>
                                    <th>Label</th>
                                    <th>Description</th>
                                    <th>Permissions</th>
                                </tr>
                            </THead>
                            <TBody>
                                {visibleRoles.map((role) => (
                                    <RoleRow
                                        key={role.id}
                                        role={role}
                                        onClick={() => {
                                            history.push(`${match.url}/${role.id}`);
                                        }}
                                    />
                                ))}
                            </TBody>
                        </Table>
                    )}
                </Container>
            </CardContainer>
        </div>
    );
}

export default withInstallation(RoleList);
